<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>

export default {
  name: 'App',
  beforeCreate () {
    // 读取缓存的userInfo
    const userInfo = this.getUserInfo();
    userInfo && this.updateUserInfo(userInfo);
  },
  components: {
  }
}
</script>

<style scoped></style>
